export default __webpack_public_path__ + "static/media/twitter-dark.1d3d522c.svg";